export default __webpack_public_path__ + "static/media/17.bc86e01f.png";